import styles from './CmsColumns.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const CmsColumns = ({
  blocks,
  width,
  mobileReverse,
  groupTheme,
  ScrollIndexVertical,
  CmsComponents,
}) => (
  <div
    className={classNames(styles.container, {
      [styles[`col-${blocks?.length}`]]: !width && blocks?.length > 1,
      [styles[width]]: width,
      // reversing order of elements on mobile
      [styles.mobileReverse]: mobileReverse,
    })}
  >
    {blocks.map(block => (
      <CmsComponents
        data={{
          ...block,
          meta: { ...block.meta, container: 'full' },
          noMargin: true,
          groupTheme,
        }}
        key={`cmscolumns-${block.id}`}
        name={block.name}
        scrollIndex={ScrollIndexVertical}
      />
    ))}
  </div>
);

CmsColumns.propTypes = {
  CmsComponents: PropTypes.func.isRequired,
  ScrollIndexVertical: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  blocks: PropTypes.arrayOf(PropTypes.object),
  groupTheme: PropTypes.string,
  mobileReverse: PropTypes.bool,
  width: PropTypes.oneOf([
    'default',
    'col-1-2',
    'col-2',
    'col-2-1',
    'col-2-5',
    'col-3',
    'col-4',
    'col-5-2',
  ]),
};

export default CmsColumns;
